export default function CTASection() {
  return (
    <section className="relative w-full min-h-[500px] md:min-h-[580px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20silk%20fabric%20in%20warm%20sand%20and%20cream%20tones%20draped%20artistically%20on%20minimal%20surface%2C%20soft%20ethereal%20lighting%2C%20elegant%20texture%20photography%2C%20neutral%20palette%2C%20clean%20contemporary%20aesthetic%2C%20lots%20of%20open%20negative%20space%20on%20right%20side&width=1800&height=900&seq=cta-main-bg-v3-sb&orientation=landscape"
          alt="Visit Kaspreadsheet for the best Superbuy spreadsheet collection"
          title="Superbuy Spreadsheet Collection on Kaspreadsheet"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/35 via-black/15 to-black/25"></div>
      </div>
      <div className="relative z-10 w-full h-full min-h-[500px] md:min-h-[580px] px-4 md:px-6 lg:px-10">
        <div className="absolute top-[20%] md:top-[22%] left-4 md:left-10 lg:left-16">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.05] lowercase tracking-tight">
            superbuy
            <br />
            spreadsheet
            <br />
            <span className="text-primary-300 italic">collection</span>
          </h2>
        </div>
        <div className="absolute bottom-[18%] md:bottom-[20%] left-4 md:left-10 lg:left-16">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-7 py-4 rounded-full bg-background-50 text-foreground-900 text-sm md:text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer group"
          >
            Visit Kaspreadsheet
            <span className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </span>
          </a>
        </div>
        <div className="absolute bottom-[18%] md:bottom-[20%] right-4 md:right-10 lg:right-16 max-w-xs">
          <p className="text-sm md:text-base text-background-200/90 leading-relaxed">
            Access thousands of hand-picked products with the most comprehensive Superbuy spreadsheet collection. Updated daily with the latest finds across all 14 categories.
          </p>
        </div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 hidden md:block">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-500 text-background-50 text-base font-bold hover:bg-primary-600 transition-all duration-200 shadow-xl shadow-primary-500/30 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}